import {getOrderReferralList, getPromoPreselect} from '@/api/order'
import {mapState} from 'vuex'

export default {
  data() {
    return {
      referral_option_list: [],
      share_discount_type:'',
      share_discount:'',
      referral_id:'',
      init_referral_id:''
    }
  },
  computed: {
    ...mapState('coupon', ['referData']),
    showReferralSelect(){
      return this.referral_option_list.length>0
    },
    code_discount_info(){
      let arr = this.referral_option_list.filter(item=>item.id==this.referral_id)||[]
      let obj = {}
      if(arr.length>0){
        let {discount_type,discount} = arr[0]
        obj = {
          is_custom_ref_discount:1,
          code_discount_info:{
            discount_type,
            discount
          }
        }
      }
      return {}
      return obj
    },
    formCode(){
      let {code} = this.form||{}
      return code||''
    }
  },
  mounted(){

  },
  watch:{
    formCode:{
      immediate:true,
      async handler (val){
        // if(this.isFina) return
        // if(val){
        //   await this.mixinNetwork().getOrderReferralList({code:val},true)
        // }else {
        //   this.referral_option_list =[]
        // }
      }
    },
    editType:{
      immediate:true,
      async handler (val){
        // if(val==3){
        //   await this.mixinNetwork().getOrderReferralList({order_id:this.renewOrderId},true)
        // }
      }
    },
    'form.quo_id':{
      immediate:true,
      async handler (val){
        if(val){
          // await this.mixinNetwork().getOrderReferralList({quo_id:val},true)
        }
      }
    },
  },
  methods: {
    initReferrerId(){
      this.referral_id = this.init_referral_id
    },
    mixinNetwork(){
      return{
        getOrderReferralList:async (params,isReferralCode =false)=>{
          return
          let {quo_id='',code,order_id,trm_of_cvr,plan_type} = this.form||{}
          let extraParams = {
            order_id:this.orderId||order_id,
          }
          if(isReferralCode||this.isRenew){
            extraParams.code = this.formCode
            extraParams.quo_id = quo_id||''
          }
          if(this.isRenew){
            extraParams.quo_id = quo_id||''
          }
          if(this.isRenew&&!quo_id)
            return
          extraParams.trm_of_cvr = trm_of_cvr
          extraParams.plan_type = plan_type||this.quoteForm&&this.quoteForm.plan_type
          params = {
            ...extraParams,
            ...params
          }
          // if(this.isNewQuote){
          //   if(!params.order_id&&!this.isNewQuote||this.isNewQuote&&!params.code) {
          //     this.referral_option_list =[]
          //     return
          //   }
          // }else {
          //
          // }
          if(!params.code) {
            this.referral_option_list =[]
            return
          }
          params.class_id = this.classId


          let {data} = await getOrderReferralList(params)
          let {custom_options=[],share_discount_type,share_discount,reward,renew_reward} = data
          let {code_discount_info} = this.referData||{}
          this.referral_option_list = custom_options
          this.share_discount_type = share_discount_type
          this.share_discount = share_discount
          custom_options.some(item => {
            if (item.discount_type == share_discount_type&&item.discount==share_discount) {
              this.referral_id = item.id
              return true
            }
            return false
          })
          this.init_referral_id = this.isRenew?renew_reward:reward
          if(code_discount_info&&this.isNewQuote){
            let {discount_type,discount} = code_discount_info||{}
            custom_options.some(item => {
              if (item.discount_type == discount_type&&item.discount==discount) {
                this.referral_id = item.id
                return true
              }
              return false
            })
          }
        },
        getPromoPreselect:async (params)=>{
          if(!params.code)
            return
          let {data} = await getPromoPreselect(params)
          // .catch(err=>{
          //   let {response} = err||{}
          //   let {data} = err.response||{}
          //   let {message_language,code} = data||{}
          //   this.$message({
          //     type: 'error',
          //     message: message_language
          //   })
          // })
          let {message_language,code} = data||{}
          // this.$message({
          //   type: 'success',
          //   message: message_language
          // })
        },
      }
    }
  }
}
